import { render, staticRenderFns } from "./coupon-pkg.vue?vue&type=template&id=d8b1aa4a&scoped=true"
import script from "./coupon-pkg.vue?vue&type=script&lang=js"
export * from "./coupon-pkg.vue?vue&type=script&lang=js"
import style0 from "./coupon-pkg.vue?vue&type=style&index=0&id=d8b1aa4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b1aa4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8b1aa4a')) {
      api.createRecord('d8b1aa4a', component.options)
    } else {
      api.reload('d8b1aa4a', component.options)
    }
    module.hot.accept("./coupon-pkg.vue?vue&type=template&id=d8b1aa4a&scoped=true", function () {
      api.rerender('d8b1aa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/coupon-pkg.vue"
export default component.exports